import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

const VisionSection = () => {
  const values = [
    {
      title: "Valorisation Foncière",
      description: "Identification et structuration du foncier pour créer des projets à forte valeur ajoutée."
    },
    {
      title: "Aménagement Intégré",
      description: "Conception et réalisation de projets résidentiels intégrés dans leur environnement."
    },
    {
      title: "Développement Durable",
      description: "Engagement pour des projets respectueux de l'environnement et des communautés locales."
    },
    {
      title: "Excellence Résidentielle",
      description: "Des résidences de standing conçues pour offrir un cadre de vie d'exception."
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="vision-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Vision Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Text */}
          <div>
            <p className="text-[#2D5A27] text-sm tracking-[0.2em] uppercase mb-4 font-medium">
              Notre Vision
            </p>
            <h2 
              className="text-3xl lg:text-4xl text-[#1a1a1a] mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Créer des lieux qui s'inscrivent dans le temps
            </h2>
            <p className="text-[#666] text-lg leading-relaxed mb-6">
              Les Terres de Songon ont été pensées comme un écosystème résidentiel complet, 
              où chaque détail contribue à la qualité de vie des résidents.
            </p>
            <p className="text-[#666] text-lg leading-relaxed mb-8">
              À proximité du Golf de Songon, ce projet offre un cadre de vie privilégié, 
              aux portes d'Abidjan, dans un environnement naturel préservé.
            </p>
            <a 
              href="https://onegreendev.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#2D5A27] font-medium hover:gap-3 transition-all duration-300"
            >
              Découvrir One Green Dev
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1721222204126-e7042f2893b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMHBvb2wlMjBnbGFzcyUyMGFyY2hpdGVjdHVyZSUyMGdhcmRlbiUyMG5pZ2h0JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzcwMzM3MzU4fDA&ixlib=rb-4.1.0&q=85"
                alt="Vision Les Terres de Songon"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#2D5A27]/10 rounded-2xl -z-10" />
          </div>
        </div>

        {/* Values Grid */}
        <div>
          <h3 
            className="text-2xl text-[#1a1a1a] mb-10 text-center"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Nos Engagements
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value) => (
              <div 
                key={value.title} 
                className="bg-[#FAFAFA] rounded-xl p-6 hover:bg-[#F5F5F5] transition-colors group"
              >
                <div className="w-10 h-10 bg-[#2D5A27]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#2D5A27]/20 transition-colors">
                  <Check className="w-5 h-5 text-[#2D5A27]" />
                </div>
                <h4 className="text-lg font-medium text-[#1a1a1a] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {value.title}
                </h4>
                <p className="text-[#666] text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
